import React from 'react';
import { Backdrop, CircularProgress, styled } from '@mui/material';

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 1,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  backdropFilter: 'blur(4px)',
  color: '#fff',
}));

const LoaderContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  position: 'relative',
});

const TextAnimation = styled('div')({
  position: 'absolute',
  display: 'flex',
  gap: '2px',
});

const Letter = styled('span')(({ theme }) => ({
  fontSize: '0.75rem',
  fontWeight: 'bold',
  animation: '$pulse 1.5s ease-in-out infinite',
  '@keyframes pulse': {
    '0%, 100%': { opacity: 0.3, transform: 'translateY(0)' },
    '50%': { opacity: 1, transform: 'translateY(-5px)' },
  },
  '&:nth-of-type(2)': {
    animationDelay: '0.2s',
  },
  '&:nth-of-type(3)': {
    animationDelay: '0.4s',
  },
}));

interface PageLoaderProps {
  active: boolean;
}

export const PageLoader: React.FC<PageLoaderProps> = ({ active }) => {
  if (!active) return null;

  return (
    <StyledBackdrop open={active}>
      <LoaderContainer>
        <CircularProgress 
          size={60} 
          thickness={4}
          sx={{ color: '#fff' }} 
        />
        <TextAnimation>
          {['S', 'M', 'P'].map((letter, index) => (
            <Letter key={index}>{letter}</Letter>
          ))}
        </TextAnimation>
      </LoaderContainer>
    </StyledBackdrop>
  );
};